const getCounterValue = state => state.counter.value;

export { getCounterValue };
